import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';
import { getLevelCount } from '../../content/curriculum/curriculumStorage';

const initialState = {
  itemsPlayed: [],
  highestLevelUnlocked: 0,
};

const progressReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        itemsPlayed: new Array(5).fill(false),
      };

    case REDUX_ACTIONS.MARK_ITEM_AS_PLAYED: {
      const { index } = payload;
      const nextItemsPlayed = [...state.itemsPlayed];
      nextItemsPlayed[index] = true;
      return {
        ...state,
        itemsPlayed: nextItemsPlayed,
      };
    }

    case REDUX_ACTIONS.MASTER_LEVEL: {
      return {
        ...state,
        highestLevelUnlocked: Math.min(
          Math.max(payload.levelIndex, state.highestLevelUnlocked),
          getLevelCount() - 1,
        ),
      };
    }

    default:
      return state;
  }
};

export default progressReducer;
